export default "__VITE_ASSET__1759bd0b__"